import type * as React from 'react'

// NOTE (Phase 00 contract gap, still open): reference/ICON-NORMALISATION.md §(c) specifies a
// shared `SvgIconProps` from './types.ts'. That file has no owning task in any phase file yet
// (flagged in PHASE-00's Notes as an open gap). This component must not create `./types.ts`
// unprompted, so the prop type is inlined here rather than imported. Once `./types.ts` exists,
// this local type should be replaced with an import from it to match every other icon component.
type SvgIconProps = Omit<React.SVGProps<SVGSVGElement>, 'children'> & {
  /** Accessible name. Omit for a purely decorative icon (default: aria-hidden). */
  title?: string
}

export function IconClose16({ title, ...rest }: SvgIconProps) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M11.9697 2.96967C12.2626 2.67678 12.7373 2.67678 13.0302 2.96967C13.323 3.26257 13.3231 3.73736 13.0302 4.03022L9.06049 7.99994L13.0302 11.9697C13.323 12.2626 13.3231 12.7374 13.0302 13.0302C12.7374 13.3231 12.2626 13.323 11.9697 13.0302L7.99994 9.06049L4.03022 13.0302C3.73736 13.3231 3.26257 13.323 2.96967 13.0302C2.67678 12.7373 2.67678 12.2626 2.96967 11.9697L6.9394 7.99994L2.96967 4.03022C2.67678 3.73732 2.67678 3.26256 2.96967 2.96967C3.26256 2.67678 3.73732 2.67678 4.03022 2.96967L7.99994 6.9394L11.9697 2.96967Z"
        fill="currentColor"
      />
    </svg>
  )
}
